import { IExperiment, TExperiments } from '../../types/experiments';

export function getExperiment(experiments: TExperiments, experimentName: string): IExperiment | undefined {
  return experimentName in experiments ? { experimentName, groupName: experiments[experimentName] } : undefined;
}

export function isExperimentActive(
  experiments: TExperiments,
  experimentName: string,
  group: string | string[] | null,
): boolean {
  const experiment = getExperiment(experiments, experimentName);

  if (!experiment) {
    return false;
  }

  return Array.isArray(group) && experiment.groupName
    ? group.includes(experiment.groupName)
    : experiment.groupName === group;
}
